import React, { Component } from "react";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import util from "../util/util";

// generate arry of rule statuses;
const ruleStatuses = () => {
  const statuses = [];

  [`All`, `Live`, `Expired`, `Future`].forEach(key => {
    statuses.push({
      label: key,
      value: key.toLowerCase()
    });
  });

  return statuses;
};

// default values in case nothing is supplied in the URL;
const defaultStatusValue = ruleStatuses()[1].value;
const defaultTimeSlotValue = `All`;

// use the same logic to set state (on load, on prop change);
const returnSearchState = (props = {}) => ({
  search: props.search || ``, // search string value;
  status: props.status || defaultStatusValue, // status value;
  timeslot: props.timeslot || defaultTimeSlotValue // timeslot value;
});

export default class RuleListSearchForm extends Component {
  constructor(props) {
    super(props);

    this.state = returnSearchState(props);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(returnSearchState(nextProps));
  }

  render() {
    return (
      <div className="form-inline search-form">
        <div className="form-group">
          <label htmlFor="search-form__search">Search</label>
          <input
            type="text"
            id="search-form__search"
            className="form-control"
            value={this.state.search}
            autoFocus
            onChange={e => this.setState({ search: e.target.value.trim() })}
            onKeyPress={e => this.onKeyPress(e)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="search-form__status">Status</label>
          <select
            id="search-form__status"
            className="form-control"
            value={this.state.status}
            onChange={e => this.setState({ status: e.target.value })}
          >
            {ruleStatuses().map(obj => (
              <option key={obj.value} value={obj.value}>
                {obj.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="search-form__timeslot">Time Slot</label>
          <select
            id="search-form__timeslot"
            className="form-control"
            value={this.state.timeslot}
            onChange={e => {
              this.setState({
                timeslot: [].slice
                  .call(e.target.selectedOptions)
                  .map(option => option.value)
              });
            }}
          >
            <option>{defaultTimeSlotValue}</option>
            {util.timeSlots.map((timeSlot, index) => {
              return (
                <option value={timeSlot} key={index}>
                  {timeSlot}
                </option>
              );
            })}
          </select>
        </div>

        <div className="search-form__buttons search-form__buttons--block">
          <button
            className="btn btn-default"
            onClick={() => this.onSearchSubmit()}
          >
            <i className="fa fa-search" aria-hidden="true"></i>
            Apply Filters
          </button>

          <button className="btn btn-link" onClick={() => this.onSearchReset()}>
            Reset Filters
          </button>
        </div>
      </div>
    );
  }

  // if the key pressed is `enter` then submit the search form;
  onKeyPress(e) {
    if (e.key === `Enter`) {
      this.onSearchSubmit();
    }
  }

  // reset search form values to their default state;
  onSearchReset() {
    this.setState(returnSearchState());
  }

  // go to a new URL with the selected form values;
  onSearchSubmit() {
    let url = `${util.returnRuleListUrl()}?sort=${this.props.sort}`;

    if (this.state.search.length) {
      url = `${url}&search=${this.state.search}`;
    }

    if (this.state.status) {
      url = `${url}&status=${this.state.status}`;
    }

    if (this.state.timeslot) {
      url = `${url}&timeslot=${this.state.timeslot}`;
    }

    browserHistory.push(url);
  }
}

RuleListSearchForm.propTypes = {
  search: PropTypes.string,
  sort: PropTypes.string, // not editable from this component, but needs to be passed in the form;
  status: PropTypes.string,
  timeslot: PropTypes.string
};
